import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../../utils/baseQuery";
import {
  ApiEnvelope,
  BusinessPlanImportRequest,
  BusinessPlanImportResult,
  BusinessPlanImportSummary,
  BusinessPlanMappingRequest,
  BusinessPlanPairView,
  BusinessPlanView,
  ControlBoardView,
} from "../../types/controlBoard";

/** Tablero de control y Business Plan. Solo Admin y Pricing. */
export const controlBoardApi = createApi({
  reducerPath: "controlBoardApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["ControlBoard", "BusinessPlan"],
  endpoints: (builder) => ({
    // GET /control-board?year= — líneas × mes con previsto y real, y el BP activo.
    getControlBoard: builder.query<ApiEnvelope<ControlBoardView>, number>({
      query: (year) => `/control-board?year=${year}`,
      providesTags: ["ControlBoard"],
    }),
    // GET /control-board/business-plan?year= — plan activo, versiones y emparejamientos.
    getBusinessPlan: builder.query<ApiEnvelope<BusinessPlanView>, number>({
      query: (year) => `/control-board/business-plan?year=${year}`,
      providesTags: ["BusinessPlan"],
    }),
    importBusinessPlan: builder.mutation<
      ApiEnvelope<BusinessPlanImportResult>,
      BusinessPlanImportRequest
    >({
      query: (body) => ({
        url: "/control-board/business-plan/imports",
        method: "POST",
        body,
      }),
      invalidatesTags: ["BusinessPlan", "ControlBoard"],
    }),
    activateBusinessPlanImport: builder.mutation<
      ApiEnvelope<BusinessPlanImportSummary>,
      string
    >({
      query: (id) => ({
        url: `/control-board/business-plan/imports/${id}/activate`,
        method: "POST",
      }),
      invalidatesTags: ["BusinessPlan", "ControlBoard"],
    }),
    deleteBusinessPlanImport: builder.mutation<ApiEnvelope<null>, string>({
      query: (id) => ({
        url: `/control-board/business-plan/imports/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["BusinessPlan"],
    }),
    setBusinessPlanMapping: builder.mutation<
      ApiEnvelope<BusinessPlanPairView>,
      BusinessPlanMappingRequest
    >({
      query: (body) => ({
        url: "/control-board/business-plan/mappings",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["BusinessPlan", "ControlBoard"],
    }),
  }),
});

export const {
  useGetControlBoardQuery,
  useGetBusinessPlanQuery,
  useImportBusinessPlanMutation,
  useActivateBusinessPlanImportMutation,
  useDeleteBusinessPlanImportMutation,
  useSetBusinessPlanMappingMutation,
} = controlBoardApi;
